var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.inputList,"itemValue":"id","item-text":_vm.inputName,"disabled":!_vm.canEdit,"label":"Input","hide-details":"","outlined":""},on:{"change":_vm.valueChanged},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }